var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { BinartIconWrapper, BinartInlineWrapper, BinartLabel, HiddenCheckbox } from './subcomponents';
const Binart = (_a) => {
    var { className, disabled, hasError, icon, id, isSelected, label, labelProps, onClick, binartRef } = _a, props = __rest(_a, ["className", "disabled", "hasError", "icon", "id", "isSelected", "label", "labelProps", "onClick", "binartRef"]);
    return (React.createElement(BinartLabel, Object.assign({ id: `${id}-label`, className: className }, labelProps),
        React.createElement(BinartInlineWrapper, { className: "binart-label", isSelected: isSelected }, label),
        React.createElement(HiddenCheckbox, Object.assign({}, props, { disabled: disabled, checked: isSelected, onChange: onClick, ref: binartRef })),
        React.createElement(BinartIconWrapper, { className: "binart-icon-wrapper", id: `${id}-icon-wrapper`, hasError: hasError, disabled: disabled, isSelected: isSelected }, icon)));
};
export default Binart;
